import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicDivisionAlgorithms = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="RESTORING & NON-RESTORING DIVISION"
      videos={[
        "https://www.youtube.com/embed/6ToR6vuRb3M", // Restoring Division Algorithm
        "https://www.youtube.com/embed/tAeuspBRz5g", // Non-Restoring Division Algorithm
      ]}
      takeaways={[
        { text: "Restoring Division Algorithm follows a traditional approach where the remainder is restored if the subtraction results in a negative value." },
        { text: "- First video explains Restoring Division with an example." },
        { text: "Non-Restoring Division Algorithm avoids restoring steps and provides an optimized method for division." },
        { text: "- Second video explains Non-Restoring Division with step-by-step examples." },
        { text: "Direct questions on these topics are common in exams." },
        { text: "Practice different models, especially cases where dividend and divisor have different signs (both negative, one negative & one positive)." },
        { text: "Multiplication and division algorithms require practice. Remembering the flowcharts can help in answering shorter (3-5 mark) questions." },
      ]}
      questions={[
        
      ]}
      exampleVideos={[]} // No additional example videos provided
    />
);
}

export default ModuleSubtopicDivisionAlgorithms;
